import React from 'react';
import './style.scss';
import { Image, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import Button from '../../../Shared/components/controls/Button';
import useWindowSize from '../../../Shared/hooks/useWindowSize';

const HeaderBannerCardsContentComponent = ({
  title, //required
  text,
  image, //required
  link,
  primaryButton,
  secondaryButton,
}) => {
  const [sizeX] = useWindowSize();
  const needText = !!text?.value;
  const needLink = !!link?.value?.href;
  const needPrimaryButton = !!primaryButton?.value?.href;
  const needSecondaryButton = !!secondaryButton?.value?.href;
  const needCTA = needLink || needPrimaryButton || needSecondaryButton;

  const CTA = ({ className }) => (
    <div className={className}>
      {needPrimaryButton && <Button color="secondary" variant="contained" link={primaryButton} />}
      {needSecondaryButton && (
        <Button color="secondary" variant="contained" link={secondaryButton} />
      )}
      {needLink && <Button color="secondary" variant="text" arrow="right" link={link} />}
    </div>
  );

  const isDesktop = sizeX >= 992;
  const isMobile = sizeX < 500;

  const textPosition = (() => {
    if (!needText) return null;
    //calculating approx height of title + desc
    //if it's less than certain number - positioning text under title
    const smallSize = title.value?.length < 30 && text.value?.length < 79;
    if (isDesktop || (smallSize && !isMobile)) return 'desktop';
    return 'general';
  })();

  return (
    (needText || needLink || needPrimaryButton || needSecondaryButton || needCTA) && (
      <div className="hbc-content">
        <div className="hbc-content-container">
          <div className="hbcc-image-wrapper">
            <Image field={image} className="hbcc-image" />
          </div>
          <div className="hbcc-description">
            <h3 className="hbcc-desc-title">
              <Text field={title} />
            </h3>
            {textPosition === 'desktop' && <RichText className="hbcc-desc-text" field={text} />}
            {needCTA && isDesktop && <CTA className="hbcc-desc-cta" />}
          </div>
        </div>
        {textPosition === 'general' && <RichText className="hbcc-text" field={text} />}
        {needCTA && !isDesktop && <CTA className="hbcc-cta" />}
      </div>
    )
  );
};

export default HeaderBannerCardsContentComponent;
